import axios from '../http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块,post数据需要qs格式化
import base from './base'// 导入接口域名列表
//招募计划相关接口
;

const myAllWork = {
  //列表数据-管理员
  getPage(params) {
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/partner/authUserwx/page`, params);
  },
  //列表数据
  myPageAuth(params) {
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/partner/authUserwx/myPageAuth`, params);
  },
  //多个授权
  saveOrUpdate(params) {
    return axios.post(`${base.bs}/admin/partner/authUserwx/set`, params)
  },
  //全部授权
  authAll(params) {
    return axios.post(`${base.bs}/admin/partner/authUserwx/saveAllByPartner/${params.partnerid}`, params.queryInfo)
  },
  //全部撤销
  delByPartner(params) {
    return axios.post(`${base.bs}/admin/partner/authUserwx/delByPartner/${params.partnerid}`, null)
  },
//根据id删除单个
  del(params) {
    return axios.get(`${base.bs}/admin/partner/authUserwx/del/${params.id}`)
  },
  //批量删除
  batchDel(params) {
    return axios.post(`${base.bs}/admin/partner/authUserwx/batchDel`,params)
  },
}
// 导出接口
export default myAllWork;



// WEBPACK FOOTER //
// ./src/request/api/partnerAuthUserwx.js